import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

export default function VideoSection() {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="film" className="bg-[#F8F9FA] py-24 md:py-32 px-5 md:px-10" data-testid="video-section">
      <div className="max-w-5xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-xs uppercase tracking-[0.3em] font-semibold text-electric mb-6"
        >
          The Film
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy mb-10"
        >
          From <span className="italic font-medium text-electric">humble beginnings.</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="relative aspect-video overflow-hidden rounded-sm border border-navy/10 shadow-[0_40px_80px_-32px_rgba(10,25,47,0.45)] group bg-navy"
          data-testid="video-player-wrap"
        >
          {playing ? (
            <video
              controls
              autoPlay
              playsInline
              className="w-full h-full"
              data-testid="video-player"
            >
              <source src="/videos/humble-beginnings.mp4" type="video/mp4" />
              <source src="/videos/humble-beginnings.webm" type="video/webm" />
            </video>
          ) : (
            <>
              <img
                src="/videos/humble-beginnings-poster.jpg"
                alt="Opening scene of From Humble Beginnings — the hills of the Fort Berthold Reservation"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-navy/20" />
              <button
                onClick={() => setPlaying(true)}
                className="absolute inset-0 flex flex-col items-center justify-center gap-5 cursor-pointer focus:outline-none focus:ring-2 focus:ring-white/60"
                data-testid="video-play-btn"
                aria-label="Play the From Humble Beginnings film"
              >
                <span className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-electric/90 text-white shadow-[0_0_50px_rgba(0,85,255,0.5)] transition-transform duration-300 group-hover:scale-110">
                  <Play className="w-6 h-6 md:w-8 md:h-8 fill-current translate-x-0.5" />
                </span>
                <span className="text-[11px] md:text-xs uppercase tracking-[0.3em] font-semibold text-white/90">
                  Watch the film · 9 min
                </span>
              </button>
            </>
          )}
        </motion.div>
      </div>
    </section>
  );
}
